import type chineseEntryNamespaces from './resources/zh-entry';
import type englishPageNamespaces from './resources/en-pages';
import type chineseNamespaces from './resources/zh-CN';

let chineseTranslations: Promise<typeof chineseNamespaces> | undefined;

/** Public translations share one request; a failed attempt is not an application cache hit. */
export function loadChineseTranslations() {
  chineseTranslations ??= import('./resources/zh-CN')
    .then((module) => module.default)
    .catch((error: unknown) => {
      chineseTranslations = undefined;
      throw error;
    });
  return chineseTranslations;
}

let englishPageTranslations: Promise<typeof englishPageNamespaces> | undefined;

/** A shared page import starts only after leaving the minimal home; reload can retry failures. */
export function loadEnglishPageTranslations() {
  englishPageTranslations ??= import('./resources/en-pages')
    .then((module) => module.default)
    .catch((error: unknown) => {
      englishPageTranslations = undefined;
      throw error;
    });
  return englishPageTranslations;
}

let chineseEntryTranslations:
  Promise<typeof chineseEntryNamespaces> | undefined;

/** Public home copy can prepare before the original complete selected language. */
export function loadChineseEntryTranslations() {
  chineseEntryTranslations ??= import('./resources/zh-entry')
    .then((module) => module.default)
    .catch((error: unknown) => {
      chineseEntryTranslations = undefined;
      throw error;
    });
  return chineseEntryTranslations;
}
